import { PaymentOptions } from "../Account/SettingsView"

export type Invoice = {
    price: number,
    id: number
    status: InvoiceStatus,
    link: string,
    siteId: number,
}

export type Customer = {
    firstName: string,
    lastName: string,
    id: number,
    email: string,
    adress: string,
    zipCode: number,
    city: string
}

export type Subscription = {
    agreement: string,
    startDate: Date,
    /**Number of months for agreement (eg. 1 month "avtalsperiod") */
    period: number,
    id: number,
    adress: string,
    paymentName: PaymentOptions
}

export enum InvoiceStatus {
    Paid = "Betald",
    Unpaid = "Obetald",
    Expired = "Förfallit"
}
/*
export type ConsumptionMonth = {
    amountOfDays: number,
    volume: number,
    month: Date
}

export type ConsumptionDay = {
    amountOfHours: number,
    volume: number,
    date: Date,
    status: string;
}*/

//Mer generell ersätter båda
export type ConsumptionBar = {
    amountOfAvg: number,
    totalVolume: number,
    date: Date,
    status?: string
}

export type Bar = {
    label: string,
    volume: number,
    description: string,
}

export enum AccountViews {
    subscriptions = "subscriptions",
    customer = "customer",
    settings = "settings",
    general = "general"
}

/**
 * Data required for the app to be considered loaded. 
 */
export type RequiredData = {
    customer: Customer;
    subscriptions: Subscription[];
    invoices: Invoice[];
};

export type AddressChange = {
    date: string;
    dayPhone: string;
    mobile: string;
    email: string;
    address: string;
    postalCode: string;
    city: string;
    careOf: string;
}